<div class="logo-tester-container">
  <h2>🎨 Test de Logos por Webhook</h2>

  <div class="form-section">
    <h3>Enviar Solicitud de Logo</h3>

    <form [formGroup]="logoForm" (ngSubmit)="onSubmit()">
      <div class="form-group">
        <label>Teléfono (Celular WhatsApp)*</label>
        <input
          type="tel"
          placeholder="+573001112233"
          formControlName="phone_number"
          class="form-control"
        />
      </div>

      <div class="form-group">
        <label>Nombre de Marca*</label>
        <input
          type="text"
          placeholder="Café La Esquina"
          formControlName="brand_name"
          class="form-control"
        />
      </div>

      <div class="form-group">
        <label>Descripción del Logo*</label>
        <textarea
          placeholder="Logo moderno de una taza de café con elementos minimalistas"
          formControlName="logo_description"
          class="form-control"
          rows="3"
        ></textarea>
      </div>

      <div class="form-group">
        <label>Colores Preferidos</label>
        <input
          type="text"
          placeholder="Marrón, blanco, dorado"
          formControlName="preferred_colors"
          class="form-control"
        />
      </div>

      <button
        type="submit"
        class="btn-primary"
        [disabled]="!logoForm.valid || isLoading"
      >
        <span *ngIf="isLoading" class="spinner"></span>
        {{ isLoading ? "Enviando..." : "Enviar Solicitud" }}
      </button>
    </form>
  </div>

  <!-- Historial -->
  <div class="history-section" *ngIf="logoTests && logoTests.length > 0">
    <h3>Historial de Logos</h3>

    <div class="filters">
      <select [(ngModel)]="filterStatus" (change)="loadLogos()">
        <option value="">Todos</option>
        <option value="processing">Procesando</option>
        <option value="done">Listos</option>
        <option value="failed">Fallidos</option>
      </select>
    </div>

    <div class="logo-grid">
      <div
        *ngFor="let logo of logoTests"
        class="logo-card"
        [ngClass]="'status-' + logo.status"
      >
        <div class="card-header">
          <span class="status-badge">{{ getStatusLabel(logo.status) }}</span>
          <span class="date">{{ logo.created_at | date: "short" }}</span>
        </div>

        <div class="card-content">
          <div class="text-item">
            <strong>Marca:</strong>
            <p>{{ getLoboBrandFromText(logo.text) }}</p>
          </div>

          <div class="text-item">
            <strong>Descripción:</strong>
            <p>{{ getLogoDescFromText(logo.text) | slice: 0 : 100 }}...</p>
          </div>

          <div class="job-id">
            <strong>Job ID:</strong>
            <code>{{ logo.job_id }}</code>
            <button
              (click)="copyJobId(logo.job_id)"
              class="btn-copy"
              title="Copiar"
            >
              📋
            </button>
          </div>

          <div class="attempts">
            <strong>Intentos:</strong> {{ logo.polling_attempts }}/120
          </div>
        </div>

        <div class="card-image" *ngIf="logo.logo_image_url">
          <img
            [src]="logo.logo_image_url"
            [alt]="getLoboBrandFromText(logo.text)"
          />
        </div>

        <div class="card-actions">
          <button
            *ngIf="logo.status === 'processing'"
            (click)="pollLogoStatus(logo.job_id)"
            class="btn-secondary"
          >
            🔄 Actualizar
          </button>

          <button
            *ngIf="logo.logo_image_url"
            (click)="downloadImage(logo.logo_image_url)"
            class="btn-success"
          >
            📥 Descargar
          </button>

          <button
            *ngIf="logo.logo_image_url"
            (click)="shareImage(logo)"
            class="btn-info"
          >
            📤 Compartir
          </button>
        </div>
      </div>
    </div>

    <!-- Paginación -->
    <div class="pagination" *ngIf="totalLogos > limit">
      <button
        [disabled]="currentPage === 1"
        (click)="previousPage()"
        class="btn-secondary"
      >
        ← Anterior
      </button>
      <span class="page-info"
        >Página {{ currentPage }} de {{ totalPages }}</span
      >
      <button
        [disabled]="currentPage >= totalPages"
        (click)="nextPage()"
        class="btn-secondary"
      >
        Siguiente →
      </button>
    </div>
  </div>

  <!-- Mensaje de éxito -->
  <div *ngIf="successMessage" class="alert alert-success">
    ✅ {{ successMessage }}
  </div>

  <!-- Mensaje de error -->
  <div *ngIf="errorMessage" class="alert alert-error">
    ❌ {{ errorMessage }}
  </div>
</div>
